import React from 'react';
import styles from './NoDataView.module.scss';

export const NoDataView = ({ label }) => (
  <div className={styles.emptyView}>
    <span>{label}</span>
  </div>
);
